"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";
import Image from "next/image";

const portfolioImages = [
  "/portfolioNew1.webp",
  "/portfolioNew2.webp",
  "/ats1.webp",
  "/portfolioNew3.webp",
  "/luxe1.webp",
];

const Portfolio = () => {
  return (
    <section
      id="portfolio"
      className="relative min-h-full md:min-h-screen  px-4 sm:px-6 md:px-12 py-8 md:py-16 pt-6"
    >
      {/* Background Image */}
      <div className="absolute inset-0 -z-10">
        <Image
          src="/4.webp"
          alt="Background"
          fill
          className="object-cover"
          quality={80}
          priority
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-primaryColor/70 " />
      </div>

      {/* Heading */}
      <motion.h1
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif text-[#A65D5D] text-center leading-tight mb-10 md:mb-12 max-w-4xl mx-auto"
      >
        Portfolio
      </motion.h1>

      {/* Carousel */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
        className="relative max-w-7xl mx-auto"
      >
        <Swiper
          modules={[Navigation, Autoplay]}
          centeredSlides={true}
          slidesPerView={1.5}
          spaceBetween={20}
          loop
          navigation
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="px-4 sm:px-12 lg:px-10"
        >
          {portfolioImages.map((src, index) => (
            <SwiperSlide key={index} className="rounded-xl overflow-hidden">
              <div className="relative w-full max-w-[600px] aspect-square mx-auto transition-transform duration-200 hover:scale-105">
                <Image
                  src={src}
                  alt={`Project ${index + 1}`}
                  fill
                  className="object-contain border-2 border-red rounded-xl shadow-md"
                  loading="lazy"
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 600px"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>

      {/* CTA Button */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
        viewport={{ once: true }}
        className="mt-10 md:mt-12 flex justify-center"
      >
        <Link
          href="/gallery"
          className="inline-flex items-center gap-3 font-manrope font-semibold text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-lg bg-[#A65D5D] hover:bg-[#8C4A4A] text-white transition duration-300 shadow-md group"
        >
          Explore the Full Gallery
          <ArrowRight className="w-5 h-5 transition-transform duration-300 transform group-hover:translate-x-1" />
        </Link>
      </motion.div>

      <style jsx global>{`
  .swiper-button-prev,
  .swiper-button-next {
    color: white; /* Changes default blue to your brand color */
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 36px; /* Optional: Adjust size */
  }

  .swiper-slide-active img {
    position: relative;
    z-index: 10;
  }
`}</style>

    </section>
  );
};

export default Portfolio;
